<!-- #259 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        List of Address(es)
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="addresses"
      :loading="loader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-row class="mt-0">
          <v-col cols="12" md="6" class="d-flex flex-column align-left pt-0">
            <v-toolbar-title class="pl-4 text-h6">
              Address(es)
            </v-toolbar-title>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end pt-0">
            <v-btn
              color="primary"
              dark
              class="mb-2 text-end mr-4"
              small
              v-if="
                checkPermission('app_carrier_partner:carrier_address_create')
              "
              @click="addAddress()"
              >Add New Address</v-btn
            >
            <v-select
              v-model="selectedCarriedId"
              label="Name"
              :rules="[(v) => !!v || 'Carriers is required.']"
              class="required pt-0 pb-0"
              item-text="name"
              item-value="id"
              hide-details
              :items="activeCarriersListTypes"
              @change="carrierTypeList()"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-2"></v-divider>

        <v-dialog
          v-model="dialog"
          max-width="650px"
          @keydown.esc="close"
          persistent
        >
          <v-card>
            <v-card-title>
              <span class="text-h5"
                >{{ formTitle }} Address
                <i class="caption red--text ml-4"> * required field</i></span
              >
            </v-card-title>
            <v-divider class="mt-3"></v-divider>
            <v-card-text>
              <v-container>
                <v-form ref="form">
                  <v-row>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-select
                        v-model="editedAddress.address_type"
                        label="Address Type"
                        :rules="[
                          (v) =>
                            (v !== '' && v !== null) || 'Type is required.',
                        ]"
                        class="required pb-0"
                        :items="addressTypes"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.street_address"
                        maxlength="200"
                        label="Address Line1"
                        :rules="[
                          (v) =>
                            (v && !!v.trim()) || 'Address Line1 is required.',
                        ]"
                        class="required pb-0"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.address_area"
                        maxlength="200"
                        label="Address Line2"
                        outlined
                        class="pb-0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-autocomplete
                        label="Country"
                        :items="allCountries"
                        v-model="editedAddress.country_code"
                        item-text="name"
                        item-value="code"
                        :rules="[(v) => !!v || 'Country is required']"
                        class="required pb-0"
                        outlined
                        @input="cityList(editedAddress.country_code)"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-autocomplete
                        label="City"
                        :items="citiesList"
                        item-text="name"
                        item-value="name"
                        v-model="editedAddress.city_name"
                        :rules="[(v) => !!v || 'City is required']"
                        class="required pb-0"
                        :loading="cityLoader"
                        outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.zip_code"
                        label="Pincode / Zipcode"
                        outlined
                        class="pb-0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.phone_number"
                        label="Phone Number"
                        :rules="[
                          (v) =>
                            (v && !!v.trim()) || 'Phone number is required.',
                        ]"
                        class="required pb-0"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedAddress.email"
                        label="Email Id"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-switch
                        v-model="editedAddress.address_status"
                        label="Status"
                        outlined
                        hide-details
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row> </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions class="pl-8">
              <v-btn color="primary" @click="save" :loading="saveLoader">
                {{ editedIndex === -1 ? "Add" : "Update" }}
              </v-btn>
              <v-btn color="primary" class="error" @click="close">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.country_code="{ item }">
        {{ item.country_code.toUpperCase() }}
      </template>
      <template v-slot:item.address_area="{ item }">
        {{ item.street_address }}
      </template>

      <template v-slot:item.address_status="{ item }">
        {{ item.address_status == true ? "Active" : "Inactive" }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_carrier_partner:carrier_address_update')"
        >
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add new" : "Edit";
    },
    ...mapGetters(["activeCarriersListTypes"]),
  },
  async created() {
    this.selectedCarriedId = this.$route.params.id;
    this.getActiveCarriersListTypes();
    await this.getCountryList();
  },
  data: () => ({
    selectedCarriedId: "",
    dialogDelete: false,
    search: "",
    searchType: "country_id__code",
    addressTypes: [
      {
        text: "Billing",
        value: 1,
      },
    ],
    headers: [
      {
        text: "Type",
        value: "address_type_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Country",
        value: "country_code",
        class: "body-1 font-weight-bold",
      },
      {
        text: "City",
        value: "city_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Address",
        value: "address_area",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Status",
        value: "address_status",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Mobile Number",
        value: "phone_number",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Email ID",
        value: "email",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
        width: "150px",
      },
    ],
    addresses: [],
    options: {},
    total: 0,
    addressesLoader: false,
    statusLoader: false,
    editedIndex: -1,
    editedAddress: {
      address_type: "",
      street_address: "",
      address_area: "",
      city_name: "",
      country_code: "",
      zip_code: "",
      phone_number: "",
      email: "",
      address_status: false,
    },
    saveLoader: false,
    dialog: false,
    address_id: "",
    loader: false,
    citiesList: [],
    cityLoader: false,
  }),

  watch: {
    options: {
      handler() {
        this.fetchCarrierAddresses();
      },
      deep: true,
    },
    search() {
      this.fetchCarrierAddresses();
    },
    searchType() {
      if (this.search) this.fetchCarrierAddresses();
    },
  },

  methods: {
    ...mapActions([
      "getCarrierAddresses",
      "snackBar",
      "createCarrierAddress",
      "updateCarrierAddress",
      "getActiveCarriersListTypes",
      "fetchCityList",
      "getCountries",
    ]),
    async getCountryList() {
      await this.getCountries().then((res) => {
        this.allCountries = res.data;
      });
    },
    cityList(value) {
      this.cityLoader = true;
      this.fetchCityList(value).then((res) => {
        this.citiesList = res.data;
        this.cityLoader = false;
      });
    },
    fetchCarrierAddresses() {
      if (this.$route.params.id !== undefined) {
        this.addresses = [];
        this.addressesLoader = true;
        this.getCarrierAddresses(this.$route.params.id)
          .then((res) => {
            this.addressesLoader = false;
            this.addresses = res.data.records;
            this.total = res.data.total;
          })
          .catch(() => {
            this.addressesLoader = false;
          });
      }
    },
    closeConfirm() {
      this.dialogDelete = false;
    },
    addAddress() {
      if (this.selectedCarriedId == undefined) {
        this.snackBar({
          color: "error",
          message: "Carrier is required",
        });
      } else {
        this.dialog = true;
      }
    },
    removeAddress(item) {
      this.editedIndex = this.addresses.indexOf(item);
      this.editedAddress = Object.assign({}, item);
      this.dialogDelete = true;
    },
    goToDetails(id) {
      this.$router.push({
        name: "ClientAddressDetails",
        params: {
          id,
        },
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;
      if (this.editedIndex > -1) {
        this.updateCarrierAddress({
          id: this.$route.params.id,
          address_id: this.address_id,
          data: this.editedAddress,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.editedIndex = -1;
            this.editedAddress = {};

            this.fetchCarrierAddresses();
          })
          .catch(() => {
            this.dialog = false;
            this.editedIndex = -1;
            this.editedAddress = {};

            this.saveLoader = false;
          });
      } else {
        this.createCarrierAddress({
          id: this.$route.params.id,
          params: this.editedAddress,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.fetchCarrierAddresses();
          })
          .catch(() => {
            this.saveLoader = false;
            this.dialog = false;
          });
      }
    },
    editItem(item) {
      this.editedIndex = this.addresses.indexOf(item);
      this.editedAddress = Object.assign({}, item);
      this.dialog = true;
      this.address_id = item.id;
      this.cityList(item.country_code);
    },
    close() {
      this.dialog = false;
      this.editedIndex = -1;

      this.editedAddress = {};
      this.$refs.form?.reset();
    },
    carrierTypeList() {
      this.$route.params.id = this.selectedCarriedId;
      this.id = this.selectedCarriedId;
      this.$router.replace({
        params: {
          id: this.$route.params.id,
        },
      });
      this.fetchCarrierAddresses();
    },
  },
};
</script>
